import { useTranslation } from 'react-i18next';
import { Globe } from "lucide-react";
import Button from "./Button"; 

export default function LanguageToggle() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const toggleLanguage = () => {
    i18n.changeLanguage(currentLang === 'vi' ? 'en' : 'vi');
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center space-x-2 text-gray-700 hover:text-sky-600 hover:bg-sky-50 border border-gray-200 bg-white rounded-lg px-1.5 sm:px-2 py-1 shadow-sm hover:shadow-md transition-all duration-300"
    >
      <Globe className="h-3 w-3 hidden sm:inline-block" />
      <span className="font-medium text-xs sm:text-sm">{currentLang === "vi" ? "VN" : "EN"}</span>
      <div className="flex items-center space-x-1">
        <div
          className={`w-6 h-3 rounded-full p-0.5 transition-all duration-300 border ${
            currentLang === "vi" ? "bg-red-500 border-red-600" : "bg-blue-500 border-blue-600"
          }`}
        >
          <div
            className={`w-2 h-2 rounded-full bg-white transition-transform duration-300 shadow-sm ${
              currentLang === "vi" ? "translate-x-0" : "translate-x-3"
            }`}
          />
        </div>
      </div>
    </Button>
  );
}
